import script from "./MonthTag.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthTag.vue?vue&type=script&setup=true&lang=js"

import "./MonthTag.vue?vue&type=style&index=0&id=b60c2fa2&scoped=true&lang=scss"

import exportComponent from "E:\\docker\\sakae\\htdocs\\sakae-race-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b60c2fa2"]])

export default __exports__